import { FaWhatsapp } from "react-icons/fa";
import { CONTACT_DETAILS } from "../../data/config";
import "./WhatsAppFloatButton.css";

const WHATSAPP_MESSAGE = `Hi!
Welcome to Xplooreze – India’s platform for skill-based learning & mentoring.
We’re thrilled to have you here!
Choose how you’d like to join:
Join as a Tutor/Mentor – Share your expertise & earn while teaching: https://www.xplooreze.in/authentication?authType=registration&userRole=tutor
Join as a Learner – Find the right tutor & start your learning journey: https://www.xplooreze.in/authentication?authType=registration&userRole=student
If you have any questions or need help with the form, just reply to this message—we’re here to support you.
Let’s grow & learn together!
Team Xplooreze
`;

export default function WhatsAppFloatButton() {
  const phone = `91${CONTACT_DETAILS.whatsapp}`;

  const handleClick = () => {
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
      "_blank",
    );
  };

  return (
    <FaWhatsapp
      className="whatsapp-float-button"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label="Chat on WhatsApp"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
    />
  );
}
